import React, { useState } from "react";
import styles from "./ResetPassword.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "components/shared/toast/toast";
import { emailRegex } from "utils/regex";
import { FORGOT_PASSWORD, LOGIN, RESET_PASSWORD } from "services/apiEndpoints";
import publicRequest from "services/publicRequest";
import LoginLayout from "components/layouts/loginlayout/LoginLayout";
import * as Yup from "yup"
import { combineClasses, requiredMessage } from "utils/utils";
import { Form, Formik } from 'formik';
import FormikControl from "components/formikcontrols/FormikControl";
import Button from 'components/shared/button/Button';
import { PATH } from "utils/constants";
import { IconButton, InputAdornment, InputLabel, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const ResetPassword = () => {

    const { token } = useParams();
    const location = useLocation();
    console.log('location :>> ', location);
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const initialValues = {
        newPassword: "",
    }

    // const validationSchema = Yup.object({
    //     newPassword: Yup.string().required(requiredMessage("Email ID")).matches(emailRegex, "Invalid email format!"),

    // })

    const validationSchema = Yup.object({
        newPassword: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters long')
            .matches(/[A-Za-z]/, 'Password must contain at least one letter')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one symbol')
    });

    // const resetPassword = (newPassword) => {
    //     console.log('newPassword :>> ', newPassword);
    //     return publicRequest.post(`${RESET_PASSWORD}/${token}` , newPassword)
    // }

    const handleSubmit = async (values) => {

        console.log('values :>> ', values);

        try {
            const res = await publicRequest.post(`${RESET_PASSWORD}/${token}`, values);
            // console.log('res :>> ', res);
            toast.success(res?.data?.message)
        } catch (error) {
            console.log('error', error);
            toast.error(error?.response?.data?.error)
        }

        // await toast.promise(p, {
        //     loading: "Email sending...",
        //     success: () => "Email sent successfully",
        //     error: () => "Email not found",
        // })
        // navigate(PATH.publicRoutes.LOGIN.path, { state: { email: values.email } })
        navigate(PATH.publicRoutes.LOGIN.path);
    };

    return (
        <LoginLayout>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {formik => {
                    return (
                        <div className={styles.mainDiv}>
                            <p className={styles.heading}>Forgot Password</p>
                            <p className={styles.subHeading}>Please Enter Email ID</p>
                            <Form className={styles.form} autoComplete="off">
                                <InputLabel sx={{ fontSize: "14px", fontWeight: 600 }}>
                                    New Password<span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                {/* <FormikControl
                                    name="newPassword"
                                    control="password"
                                    label="New Password"
                                    placeholder="Enter New Password"
                                    isRequired={true}
                                /> */}
                                <TextField
                                    onChange={formik.handleChange}
                                    value={formik.values.newPassword}
                                    onBlur={formik.handleBlur}
                                    name="newPassword"
                                    size="small"
                                    type={showPassword ? "text" : "password"}
                                    margin="normal"
                                    className={styles.marginTop2px}
                                    placeholder="Enter New Password"
                                    error={Boolean(
                                        formik.errors.newPassword && formik.touched.newPassword
                                    )}
                                    sx={{
                                        "& .MuiFormHelperText-root": {
                                            margin: "2px 0px",
                                        },
                                    }}
                                    helperText={
                                        formik.errors.newPassword &&
                                        formik.touched.newPassword &&
                                        String(formik.errors.newPassword)
                                    }
                                    fullWidth
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleTogglePasswordVisibility}
                                                    edge="end"
                                                    aria-label="toggle password visibility"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                                <Button
                                    type="submit"
                                    className={styles.button}
                                    disabled={formik.isSubmitting}

                                >
                                    Submit
                                </Button>
                                <p className={styles.bottomText}>
                                    Don't have an account? <span
                                        className="link-text"
                                        onClick={() => navigate(PATH.publicRoutes.REGISTER.path)}
                                    >
                                        Sign up
                                    </span>
                                </p>
                            </Form>
                        </div>
                    )
                }}
            </Formik>
        </LoginLayout>
    );
};

export default ResetPassword;
